import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logUxEvent, setUxUserFromStorage } from './uxLogger';
import { flushSync } from './queue';

// Rotas onde a saída pode ser tão rápida (redirect para gateway, navegação
// imediata) que o flush periódico de 10s perderia o screen_view. Para essas,
// flushSync logo após enqueue garante que o beacon vai antes de qualquer
// navegação. Coincide com as etapas do funil em functions/ux/aggregate.js.
const FUNNEL_ROUTES = new Set([
  '/',
  '/consulta',
  '/email',
  '/cpf',
  '/telefone',
  '/termos',
  '/pagamento',
  '/triagem',
  '/consulta/chat',
  '/consulta/chat/pago',
]);

const buildScreenName = (location) => {
  const pathname = location.pathname || '/';
  if (pathname === '/') return 'home';
  return pathname.replace('/', '').replace(/\//g, '_') || 'unknown';
};

const buildScreenPath = (location) =>
  `${location.pathname || '/'}${location.search || ''}`;

export const useScreenView = () => {
  const location = useLocation();

  useEffect(() => {
    setUxUserFromStorage();
    logUxEvent('screen_view', {
      screen_name: buildScreenName(location),
      screen_path: buildScreenPath(location),
    });
    if (FUNNEL_ROUTES.has(location.pathname)) {
      flushSync('funnel_step');
    }
  }, [location.pathname, location.search]);
};
